import ChartDataTable from '@/pages/CompanyReport/components/Overview/components/ChartDataTable';
import DocumentSchema from '@components/DocumentSchema';
import type { Table } from 'schema-dts';
import { EarningsRevenueTableWrapper } from './styled';
import { selector } from '../../selector';
import { shallowEqual, useSelector } from 'react-redux';
import Tooltip from '@/components/Tooltip';
import {
  Term,
  TooltipTitle,
} from '@/pages/CompanyReport/components/Overview/components/Fundamentals/styled';

const EarningsRevenueTable = () => {
  const selectedState = useSelector<
    Parameters<typeof selector>[0],
    ReturnType<typeof selector>
  >(selector, shallowEqual);

  const header = `${selectedState.tickerSymbol} fundamental statistics`;
  const caption = `How do ${selectedState.companyName}'s earnings and revenue compare to its market cap?`;
  const ttm = (
    <Tooltip
      title={<TooltipTitle>Trailing 12 months</TooltipTitle>}
      light
      openDelay={300}
    >
      <Term>TTM</Term>
    </Tooltip>
  );

  return (
    <>
      <DocumentSchema<Table>
        item={{
          '@context': 'https://schema.org',
          '@type': 'Table',
          headline: header,
          about: caption,
        }}
      />
      <EarningsRevenueTableWrapper>
        <ChartDataTable
          data-cy-id="overview-earnings-revenue-table"
          columnTextAlignments="l"
        >
          <caption>{caption}</caption>
          <thead>
            <tr>
              <th
                colSpan={2}
              >{`${selectedState.tickerSymbol} fundamental statistics`}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Market Cap</td>
              <td>{selectedState.formattedMarketCap}</td>
            </tr>
            <tr>
              <td>
                {`Earnings (`}
                {ttm}
                {`)`}
              </td>
              <td>{selectedState.formattedEarnings}</td>
            </tr>
            <tr>
              <td>
                {`Revenue (`}
                {ttm}
                {`)`}
              </td>
              <td>{selectedState.formattedRevenue}</td>
            </tr>
          </tbody>
        </ChartDataTable>
      </EarningsRevenueTableWrapper>
    </>
  );
};

export default EarningsRevenueTable;
